const STORAGE_KEY = 'cibeiai_pwa_install_dismissed_at'
const DISMISS_MS = 24 * 60 * 60 * 1000

let deferredPrompt = null
const listeners = new Set()

function notifyListeners () {
  listeners.forEach((fn) => {
    try {
      fn()
    } catch (e) {
      console.warn('[PWA] listener error', e)
    }
  })
}

/** 注册 beforeinstallprompt，应在应用启动时调用一次 */
export function initPwaInstallListener () {
  if (typeof window === 'undefined') return
  if (window.__cibeiaiPwaInstallInited) return
  window.__cibeiaiPwaInstallInited = true

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt = e
    notifyListeners()
  })

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null
    notifyListeners()
  })
}

export function subscribePwaInstall (cb) {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

export function hasInstallPrompt () {
  return !!deferredPrompt
}

export async function promptPwaInstall () {
  if (!deferredPrompt) return { outcome: 'unavailable' }
  await deferredPrompt.prompt()
  const { outcome } = await deferredPrompt.userChoice
  if (outcome === 'accepted') {
    deferredPrompt = null
    notifyListeners()
  }
  return { outcome }
}

/** 是否以 PWA / 独立窗口方式打开 */
export function isPwaStandalone () {
  if (typeof window === 'undefined') return false
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    window.navigator.standalone === true
  )
}

export function isInstallGuideDismissed () {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return false
    const dismissedAt = Number(raw)
    if (!dismissedAt) return false
    return Date.now() - dismissedAt < DISMISS_MS
  } catch {
    return false
  }
}

/** 「稍后再说」：1 天内不再展示 */
export function dismissInstallGuide () {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now()))
  } catch {
    // ignore
  }
  notifyListeners()
}
